import { EventEmitter } from '@angular/core';
import intlTelInput from 'intl-tel-input';

export function buildIntlTelInput(input: HTMLInputElement, countryCode: string) {
  const intlTel = intlTelInput(input, {
    initialCountry: countryCode,
    separateDialCode: true,
    nationalMode: false,
    formatOnDisplay: false,
    countrySearch: true,
    utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js',
    dropdownContainer: document.body
  } as any);

  let backdrop: HTMLElement | null = null;

  input.addEventListener('open:countrydropdown', () => {
    backdrop = document.createElement('div');
    backdrop.className = 'iti-backdrop';
    backdrop.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;z-index:999;';
    backdrop.addEventListener('click', () => {
      const selectedFlag = input.closest('.iti')?.querySelector('.iti__selected-country') as HTMLElement;
      if (selectedFlag) {
        selectedFlag.click();
      }
    });
    document.body.appendChild(backdrop);
  });

  input.addEventListener('close:countrydropdown', () => {
    if (backdrop) {
      backdrop.remove();
      backdrop = null;
    }
  });

  return intlTel;
}

export function configureIntlTelInputListener(input, intlTel, countryCodeChange: EventEmitter<string>, maskRef) {
  input.addEventListener('countrychange', (_) => {
    const countryCodeValue = getCountryCodeValue(intlTel);

    countryCodeChange.emit(countryCodeValue);

    updateMask(intlTel, maskRef);
  });
}

export function updateMask(intlTel, maskRef) {
  const countryCodeValue = getCountryCodeValue(intlTel);

  maskRef.updateValue();
  maskRef.updateOptions(selectRightMask(countryCodeValue));
}

export function getCountryCodeValue(intlTel) {
  return `+${intlTel?.getSelectedCountryData()?.dialCode}`
}

function selectRightMask(phoneCountryCode) {
  const usDialCode = '+1';
  const usMask = '(000) 000-0000';

  return phoneCountryCode === usDialCode ?
    { mask: usMask } :
    { mask: `[00000000000000000000000]` }
}

export function checkFocused(flagsContainer: HTMLElement) {
  if (!!flagsContainer) {
    toggleFlagContainerVisibility('block', flagsContainer);
  }
}

export function checkFocusedout(e, flagsContainer: HTMLElement, isInputEmpty: boolean) {
  const inputEvent = e.relatedTarget;
  const isClickOnFlag = checkClass(inputEvent, 'iti__selected-country') || checkClass(inputEvent, 'iti__country') || checkClass(inputEvent, 'iti__search-input');

  if (isInputEmpty && !isClickOnFlag && !!flagsContainer) {
    /* toggleFlagContainerVisibility('none', flagsContainer); */
  }
}

function checkClass(element: HTMLElement, klass: string) {
  return element?.classList.contains(klass);
}

export function toggleFlagContainerVisibility(display: string, flagsContainer: HTMLElement) {
  if (flagsContainer) {
    flagsContainer.style.display = display;
  }
}

export function shouldValidate(intlTel) {
  return !intlTel?.isValidNumber();
}

export function destroyInput(intlTel) {
  return intlTel?.destroy();
}

export function setInputValue(intlTel, value) {
  intlTel.setNumber(value);
}

export function parsePhoneNumber(value): string {
  const parsedValue = value.replace(/[^\d+]/g, '');
  return `+${  parsedValue}`;
}
